import { CustomBox } from "components/Box/CustomBox";
import RegularButton from "components/CustomButtons/Button";
import React from "react";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import { fontSize, iconStyle } from "../CustomerView";
import { useAddLabel } from "hooks/useAddLabels";
import { useDispatch, useSelector } from "react-redux";
import { selectCustomerAccount } from "redux/actions/customers/customersAction";
import { addAccountMode } from "redux/actions/customers/customersAction";
import { SelectComponent } from "components/SelectMenu/SelectComponent";
import { orderArrayV2 } from "helpers/orderArray";
import { useHandleView } from "../useHandleView";
import { MyAutoComplete } from "components/SelectMenu/MyAutoComplete";
import { validateObject } from "helpers/validateObject";

export const CustomerAccounts = () => {
  const dispatch = useDispatch();
  const { customer, account} = useSelector(({ customersReducer }) => customersReducer);
  const selectView = useHandleView(1);

  const handleAccountSelect = (v) => {
    dispatch(selectCustomerAccount(v, 1));
  };

  const handleNewAccount = () => {
    dispatch(addAccountMode());
    selectView();
  };

  return (
    <CustomBox
      title="Cuentas Registradas"
      count={customer?.accounts?.length || 0}
      icon={<SupervisorAccountIcon style={iconStyle} />}
      bg={<SupervisorAccountIcon style={{ ...iconStyle, fontSize }} />}
    >
      {/* <SelectComponent
        label="Cuenta"
        defaultValue="Seleccione cuenta"
        options={customer?.accounts}
        onChange={handleAccountSelect}
        value={account?.id}
        formStyle={{
          position: "relative",
          zIndex: 1,
        }}
      /> */}
      <MyAutoComplete 
        label="Cuenta"
        options={customer?.accounts || []} 
        action={handleAccountSelect}
        value={validateObject(account, true) ? null : account}
        keySort = "alias"
      />
      <RegularButton
        size="sm"
        color="info"
        fullWidth
        onClick={handleNewAccount}
      >
        Nueva cuenta
      </RegularButton>
    </CustomBox>
  );
};
